import { IRMSErrorEnum } from "./action-interface/RmsDetailsActions";
class TOCJourneyPresenter {
    constructor(usecase, actions, accounDetails) {
        this.usecase = usecase;
        this.actions = actions;
        this.accounDetails = accounDetails;
        this.tocOpen = localStorage.getItem("AuthToSellSymbol") ? true : false;
    }
    getIpoCancel(req) {
        this.actions.IpoCancel.hideError();
        this.actions.IpoCancel.startLoader();
        this.usecase.getIpoCancel.execute({
            onSuccess: (data) => {
                if (data) {
                    this.actions.IpoCancel.getIpoCancel(data);
                    this.actions.IpoCancel.stopLoader();
                }
            },
            onError: (error) => {
                this.actions.IpoCancel.setError({ isOpen: true, error });
                this.actions.IpoCancel.stopLoader();
            },
        }, req);
    }
    getIpoOtpRegister(req) {
        this.actions.IpoOtpRegister.hideError();
        this.actions.IpoOtpRegister.startLoader();
        this.usecase.getIpoOtpRegister.execute({
            onSuccess: (data) => {
                if (data) {
                    this.actions.IpoOtpRegister.getIpoOtpRegister(data);
                    this.actions.IpoOtpRegister.stopLoader();
                }
            },
            onError: (error) => {
                this.actions.IpoOtpRegister.setError({ isOpen: true, error });
                this.actions.IpoOtpRegister.stopLoader();
            },
        }, req);
    }
    getIpoOtpValidate(req) {
        this.actions.IpoOtpValidate.hideError();
        this.actions.IpoOtpValidate.startLoader();
        this.usecase.getIpoOtpValidate.execute({
            onSuccess: (data) => {
                if (data) {
                    this.actions.IpoOtpValidate.getIpoOtpValidate(data);
                    this.actions.IpoOtpValidate.stopLoader();
                }
            },
            onError: (error) => {
                this.actions.IpoOtpValidate.setError({ isOpen: true, error });
                this.actions.IpoOtpValidate.stopLoader();
            },
        }, req);
    }
    getIpoBankMaster() {
        this.actions.IpoBankMaster.hideError();
        this.actions.IpoBankMaster.startLoader();
        this.usecase.getIpoBankMaster.execute({
            onSuccess: (data) => {
                if (data) {
                    this.actions.IpoBankMaster.getIpoBankMaster(data);
                    this.actions.IpoBankMaster.stopLoader();
                }
            },
            onError: (error) => {
                this.actions.IpoBankMaster.setError({ isOpen: true, error });
                this.actions.IpoBankMaster.stopLoader();
            },
        }, null);
    }
    getIpoOtpLeads(req) {
        this.actions.IpoOtpLeads.hideError();
        this.actions.IpoOtpLeads.startLoader();
        this.usecase.getIpoOtpLeads.execute({
            onSuccess: (data) => {
                if (data) {
                    this.actions.IpoOtpLeads.getIpoOtpLeads(data);
                    this.actions.IpoOtpLeads.stopLoader();
                }
            },
            onError: (error) => {
                this.actions.IpoOtpLeads.setError({ isOpen: true, error });
                this.actions.IpoOtpLeads.stopLoader();
            },
        }, req);
    }
    mfPurchaseOrder(req) {
        return new Promise((resolve, reject) => {
            this.usecase.mfPurchaseOrder.execute({
                onSuccess: (data) => resolve(data.data),
                onError: (error) => reject(error),
            }, req);
        });
    }
    getSipStartDate(req) {
        return new Promise((resolve, reject) => {
            this.usecase.mfSipStartDate.execute({
                onSuccess: (data) => resolve(data.data),
                onError: (error) => reject(error),
            }, req);
        });
    }
    getSipFrequency(req) {
        return new Promise((resolve, reject) => {
            this.usecase.mfSipFrequency.execute({
                onSuccess: (data) => resolve(data.data),
                onError: (error) => reject(error),
            }, req);
        });
    }
    getMFPurchase(req) {
        return new Promise((resolve, reject) => {
            this.usecase.mfPurchase.execute({
                onSuccess: (data) => resolve(data),
                onError: (error) => reject(error),
            }, req);
        });
    }
    getNfoPurchase(req) {
        return new Promise((resolve, reject) => {
            this.usecase.nfoPurchase.execute({
                onSuccess: (data) => resolve(data),
                onError: (error) => reject(error),
            }, req);
        });
    }
    CancelPlaceOrder(req) {
        return new Promise((resolve, reject) => {
            this.usecase.cancelPlaceOrder.execute({
                onSuccess: (data) => resolve(data),
                onError: (error) => reject(error),
            }, req);
        });
    }
    CancelEsipOrder(req) {
        return new Promise((resolve, reject) => {
            this.usecase.cancelEsipOrder.execute({
                onSuccess: (data) => resolve(data),
                onError: (error) => reject(error),
            }, req);
        });
    }
    modifyOrder(req) {
        return new Promise((resolve, reject) => {
            this.usecase.modifyOrder.execute({
                onSuccess: (data) => resolve(data),
                onError: (error) => reject(error),
            }, req);
        });
    }
    mfParticularHolding(req) {
        this.actions.mfParticularHolding.hideError();
        this.actions.mfParticularHolding.startLoader();
        this.usecase.MFParticularHolding.execute({
            onSuccess: (data) => {
                if (data) {
                    this.actions.mfParticularHolding.getMfParticularHolding(data);
                    this.actions.mfParticularHolding.stopLoader();
                }
            },
            onError: (error) => {
                this.actions.mfParticularHolding.setError({ isOpen: true, error });
                this.actions.mfParticularHolding.stopLoader();
            },
        }, req);
    }
    getMultiQuoteData(multiQuote) {
        this.actions.multiQuoteActions.hideError();
        this.actions.multiQuoteActions.startMultiQuoteloader();
        this.usecase.multiQuote.execute({
            onSuccess: (data) => {
                var _a;
                if (data) {
                    this.actions.multiQuoteActions.getMultiQuoteData(data);
                    this.actions.multiQuoteActions.stopMultiQuoteLoader();
                    if (!(multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.isModifyOrder)) {
                        this.AMOStatus({
                            exchange: (_a = data === null || data === void 0 ? void 0 : data.quotesDetailsEntity[0]) === null || _a === void 0 ? void 0 : _a.exchange,
                        });
                    }
                }
            },
            onError: (error) => {
                this.actions.multiQuoteActions.setError({ isOpen: true, error });
                this.actions.multiQuoteActions.stopMultiQuoteLoader();
            },
        }, multiQuote);
    }
    flushMultiQuoteData() {
        this.actions.multiQuoteActions.hideError();
        this.actions.multiQuoteActions.getMultiQuoteData({});
    }
    async getMultiQuote(multiQuote) {
        return new Promise((resolve, reject) => {
            this.usecase.multiQuote.execute({
                onSuccess: (data) => resolve(data.quotesDetailsEntity),
                onError: (error) => reject(error),
            }, multiQuote);
        });
    }
    clrNormalTrade() {
        this.actions.placeNormalTrade.placeNormalTrade({
            message: "",
            success: false,
            orderID: "",
        });
    }
    placeNormalTrade(req) {
        this.actions.placeNormalTrade.hideError();
        this.actions.placeNormalTrade.loader();
        this.usecase.placeNormalTrade.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.placeNormalTrade.placeNormalTrade(data);
                this.actions.placeNormalTrade.stopLoader();
            },
            onError: (error) => {
                this.actions.placeNormalTrade.setError({ isOpen: true, error });
                this.actions.placeNormalTrade.stopLoader();
            },
        }, req);
    }
    placeOfsTrade(req) {
        this.actions.placeOfsTrade.hideError();
        this.actions.placeOfsTrade.loader();
        this.usecase.placeOfsTrade.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.placeOfsTrade.placeNormalTrade(data);
                this.actions.placeOfsTrade.stopLoader();
            },
            onError: (error) => {
                this.actions.placeOfsTrade.setError({ isOpen: true, error });
                this.actions.placeOfsTrade.stopLoader();
            },
        }, req);
    }
    placeTradeComm(req) {
        this.actions.placeTradeComm.hideError();
        this.actions.placeTradeComm.loader();
        this.usecase.placeTradeComm.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.placeTradeComm.placeNormalTrade(data);
                this.actions.placeTradeComm.stopLoader();
            },
            onError: (error) => {
                this.actions.placeTradeComm.setError({ isOpen: true, error });
                this.actions.placeTradeComm.stopLoader();
            },
        }, req);
    }
    placeAMOTrade(req) {
        this.actions.placeNormalTrade.hideError();
        this.actions.placeNormalTrade.loader();
        this.usecase.amoPlaceTrade.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.placeNormalTrade.placeNormalTrade(data);
                this.actions.placeNormalTrade.stopLoader();
            },
            onError: (error) => {
                this.actions.placeNormalTrade.setError({ isOpen: true, error });
                this.actions.placeNormalTrade.stopLoader();
            },
        }, req);
    }
    flushPlaceOrderError() {
        return new Promise((res, err) => {
            this.actions.placeNormalTrade.hideError();
            this.actions.orderDetails.hideError();
            res();
        });
    }
    flushPlaceOrderData() {
        return new Promise((res, rej) => {
            this.actions.placeNormalTrade.clearData();
            this.actions.orderDetails.clearData();
            res();
        });
    }
    placeAMOTradeComm(req) {
        this.actions.placeTradeComm.hideError();
        this.actions.placeTradeComm.loader();
        this.usecase.amoPlaceTradeComm.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.placeTradeComm.placeNormalTrade(data);
                this.actions.placeTradeComm.stopLoader();
            },
            onError: (error) => {
                this.actions.placeTradeComm.setError({ isOpen: true, error });
                this.actions.placeTradeComm.stopLoader();
            },
        }, req);
    }
    placeBracketTrade(req) {
        this.actions.placeNormalTrade.hideError();
        this.actions.placeNormalTrade.loader();
        this.usecase.bracketTrade.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.placeNormalTrade.placeNormalTrade(data);
                this.actions.placeNormalTrade.stopLoader();
            },
            onError: (error) => {
                this.actions.placeNormalTrade.setError({ isOpen: true, error });
                this.actions.placeNormalTrade.stopLoader();
            },
        }, req);
    }
    placeEsipTrade(req) {
        this.actions.placeNormalTrade.hideError();
        this.actions.placeNormalTrade.loader();
        this.usecase.esipTrade.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.placeNormalTrade.placeNormalTrade(data);
                this.actions.placeNormalTrade.stopLoader();
            },
            onError: (error) => {
                this.actions.placeNormalTrade.setError({ isOpen: true, error });
                this.actions.placeNormalTrade.stopLoader();
            },
        }, req);
    }
    orderDetails(req) {
        this.actions.orderDetails.hideError();
        this.actions.orderDetails.loader();
        this.usecase.orderDetailsUseCase.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.orderDetails.orderDetails(data);
                this.actions.orderDetails.stopLoader();
            },
            onError: (error) => {
                this.actions.orderDetails.setError({ isOpen: true, error });
                this.actions.orderDetails.stopLoader();
            },
        }, req);
    }
    checkMargin(req) {
        this.actions.checkMargin.hideError();
        this.actions.checkMargin.loader();
        this.usecase.checkMargin.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.checkMargin.getCheckMargin(data);
                this.actions.checkMargin.stopLoader();
            },
            onError: (error) => {
                this.actions.checkMargin.setError({ isOpen: true, error });
                this.actions.checkMargin.stopLoader();
            },
        }, req);
    }
    flushMarginData() {
        this.actions.checkMargin.hideError();
        this.actions.checkMargin.removeMarginData();
    }
    brokerCharge(req) {
        this.actions.brokerCharges.hideError();
        this.actions.brokerCharges.loader();
        this.usecase.brokerCharge.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.brokerCharges.getBrokerCharges(data);
                this.actions.brokerCharges.stopLoader();
            },
            onError: (error) => {
                this.actions.brokerCharges.setError({ isOpen: true, error });
                this.actions.brokerCharges.stopLoader();
            },
        }, req);
    }
    brokerChargeComm(req) {
        this.actions.brokerChargesComm.hideError();
        this.actions.brokerChargesComm.loader();
        this.usecase.brokerChargeComm.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.brokerChargesComm.getBrokerCharges(data);
                this.actions.brokerChargesComm.stopLoader();
            },
            onError: (error) => {
                this.actions.brokerChargesComm.setError({ isOpen: true, error });
                this.actions.brokerChargesComm.stopLoader();
            },
        }, req);
    }
    async AMOStatus(subReq) {
        let req = {
            accType: await this.accounDetails.getAccTyp(),
            exchange: subReq.exchange,
        };
        this.actions.amoStatus.hideError();
        this.actions.amoStatus.loader();
        this.usecase.amoStatus.execute({
            onSuccess: (data) => {
                this.actions.amoStatus.AMOStatus(data);
                this.actions.amoStatus.stopLoader();
            },
            onError: (error) => {
                this.actions.amoStatus.setError({ isOpen: true, error });
                this.actions.amoStatus.stopLoader();
            },
        }, req);
    }
    async getTpinApiDetails(tpinReq) {
        let response = null;
        await this.usecase.tpinHolding.execute({
            onSuccess: (data) => {
                response = data;
            },
            onError: (error) => {
                // response.amoFlag = false;
            },
        }, tpinReq);
        return response;
    }
    getRmsSublimits(req) {
        this.actions.rmsDetails.hideError(IRMSErrorEnum.ERROR_DATA);
        this.actions.rmsDetails.startRmsSublimitsLoader();
        this.usecase.rmsSubLimits.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.rmsDetails.getRmsSublimitsData(data);
                this.actions.rmsDetails.stopRmsSublimitsLoader();
            },
            onError: (error) => {
                this.actions.rmsDetails.setError({ isOpen: true, error }, IRMSErrorEnum.ERROR_DATA);
                this.actions.rmsDetails.stopRmsSublimitsLoader();
            },
        }, req);
    }
    getLimits(req) {
        this.actions.limits.hideError(IRMSErrorEnum.ERROR_DATA);
        this.actions.limits.loader();
        this.usecase.limitsDetails.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.limits.getLimits(data);
                this.actions.rmsDetails.stopRmsSublimitsLoader();
            },
            onError: (error) => {
                this.actions.rmsDetails.setError({ isOpen: true, error }, IRMSErrorEnum.ERROR_DATA);
                this.actions.rmsDetails.stopRmsSublimitsLoader();
            },
        }, req);
    }
    getRmsHoldingDetails(req) {
        this.actions.rmsDetails.hideError(IRMSErrorEnum.RMS_HOLDING_ERROR);
        this.actions.rmsDetails.startRmsHoldingLoader();
        this.usecase.rmsHolding.execute({
            onSuccess: (data) => {
                if (data)
                    this.actions.rmsDetails.updateRmsHolding(data);
                this.actions.rmsDetails.stopRmsHoldingLoader();
            },
            onError: (error) => {
                this.actions.rmsDetails.setError({ isOpen: true, error }, IRMSErrorEnum.RMS_HOLDING_ERROR);
                this.actions.rmsDetails.stopRmsHoldingLoader();
            },
        }, req);
    }
    proceedToAuthorize(authorizePayload) {
        this.actions.proceedToAuth.hideError();
        this.actions.proceedToAuth.loader();
        this.usecase.authorize.execute({
            onSuccess: (data) => {
                var _a;
                if (data)
                    this.actions.proceedToAuth.proceedToAuth(data);
                localStorage.setItem("AuthToSellSymbol", (_a = authorizePayload === null || authorizePayload === void 0 ? void 0 : authorizePayload.lst[0]) === null || _a === void 0 ? void 0 : _a.sym);
                this.actions.proceedToAuth.stopLoader();
            },
            onError: (error) => {
                this.actions.proceedToAuth.setError({ isOpen: true, error });
                this.actions.proceedToAuth.stopLoader();
            },
        }, authorizePayload);
    }
    getUPIList(req) {
        this.actions.upiList.hideError();
        this.actions.upiList.loader();
        this.usecase.upiList.execute({
            onSuccess: (data) => {
                this.actions.upiList.getUPIList(data);
                this.actions.upiList.stopLoader();
            },
            onError: (error) => {
                this.actions.upiList.setError({
                    isOpen: true,
                    error: error,
                });
                this.actions.upiList.stopLoader();
            },
        }, req);
    }
    getSpecificIPODetails(req) {
        return new Promise((resolve, reject) => {
            this.usecase.specificIPO.execute({
                onSuccess: (data) => resolve(data),
                onError: (error) => reject(error),
            }, req);
        });
    }
    applyIPO(req) {
        return new Promise((resolve, reject) => {
            this.usecase.applyIPO.execute({
                onSuccess: (data) => resolve(data),
                onError: (error) => reject(error),
            }, req);
        });
    }
    getUserStatus(req) {
        this.actions.userStatus.hideError();
        this.actions.userStatus.startLoader();
        this.usecase.getUserStatus.execute({
            onSuccess: (data) => {
                this.actions.userStatus.stopLoader();
                this.actions.userStatus.getUserStatus(data);
            },
            onError: (error) => {
                this.actions.userStatus.stopLoader();
                this.actions.userStatus.setError({ isOpen: true, error });
            },
        }, req);
    }
}
export default TOCJourneyPresenter;
